import { STAT_CAP_MAX } from './constants';

/** Les huit statistiques (dossier §4). L'ordre fixe les touches 1–8. */
export const STATS = [
  'maxHealth',
  'regen',
  'bodyDamage',
  'moveSpeed',
  'bulletDamage',
  'penetration',
  'bulletSpeed',
  'reload',
] as const;
export type StatId = (typeof STATS)[number];
export type StatLevels = Record<StatId, number>;

/** Gain par point (fraction), avant rendements décroissants. */
export const STAT_PER_POINT: Record<StatId, number> = {
  maxHealth: 0.04,
  regen: 0.05,
  bodyDamage: 0.05,
  moveSpeed: 0.02,
  bulletDamage: 0.03,
  penetration: 0.04,
  bulletSpeed: 0.02,
  reload: 0.02,
};

/**
 * Rendements décroissants : le k-ième point vaut (1 − 0,04·(k−1)) d'un point plein.
 * 10 points valent donc 8,2 points pleins. Décision documentée dans docs/decisions.md.
 */
export function effectivePoints(n: number): number {
  // Borne absolue 20 (niveau 250) ; le plafond selon le niveau est appliqué à l'achat (statCapForLevel).
  const k = Math.max(0, Math.min(STAT_CAP_MAX, Math.floor(n)));
  return k - 0.02 * k * (k - 1);
}

export function statMultiplier(stat: StatId, points: number): number {
  return 1 + STAT_PER_POINT[stat] * effectivePoints(points);
}

export function emptyStats(): StatLevels {
  return {
    maxHealth: 0,
    regen: 0,
    bodyDamage: 0,
    moveSpeed: 0,
    bulletDamage: 0,
    penetration: 0,
    bulletSpeed: 0,
    reload: 0,
  };
}

export function spentPoints(s: StatLevels): number {
  let t = 0;
  for (const k of STATS) t += s[k];
  return t;
}
